import React, {Component} from "react";
import 'rsuite/dist/rsuite.min.css';
import { DateRangePicker } from 'rsuite';
import { subDays, addDays, startOfMonth, endOfMonth, addMonths } from 'date-fns';

export default class Paginate extends Component {

    constructor(props) {
        super(props);

        this.state = {

        }
    }

    handleDateChange = (name,selectedDates) => {
        // set 00:00:00 am to 24:59:59
        selectedDates[0].setHours(0, 0, 0, 0);
        selectedDates[1].setHours(23, 59, 59, 999);
        const timeDifference = selectedDates[1].getTime() - selectedDates[0].getTime();
        const numberOfDays = Math.floor(timeDifference / (1000 * 3600 * 24)) + 1;
        this.props.handleDateChange(name,selectedDates,numberOfDays);
    }

    //Here click event only triggered. so sent empty response and handle them.
    handleClearDate = (name,e) => {
        this.props.handleDateChange(name,'',0)
    }

    render(){

        let { config } = this.props;

        let name = config.name;
        let placeHolder = config.placeholder || `select Date Range`;
        let defaultValue = config.defaultValue || '';

        const predefinedRanges = [
            {
                label: 'Today',
                value: [new Date(), new Date()],
                placement: 'left',
                closeOverlay: false
            },
            {
                label: 'Yesterday',
                value: [addDays(new Date(), -1), addDays(new Date(), -1)],
                placement: 'left',
                closeOverlay: false
            },
            {
                label: 'Last 7 days',
                value: [subDays(new Date(), 6), new Date()],
                placement: 'left',
                closeOverlay: false
            },
            {
                label: 'Last 30 days',
                value: [subDays(new Date(), 29), new Date()],
                placement: 'left',
                closeOverlay: false
            },
            {
                label: 'This month',
                value: [startOfMonth(new Date()), new Date()],
                placement: 'left',
                closeOverlay: false
            },
            {
                label: 'Last month',
                value: [startOfMonth(addMonths(new Date(), -1)), endOfMonth(addMonths(new Date(), -1))],
                placement: 'left',
                closeOverlay: false
            }
        ];

        const { afterToday } = DateRangePicker;
        
        return (
            <DateRangePicker
                ranges={predefinedRanges}
                placement={`bottomStart`}
                cleanable={false}
                placeholder={placeHolder}
                isoWeek={true}
                defaultValue={defaultValue}
                onOk={(e)=>{this.handleDateChange(name,e)}}
                onClean={(e)=>{this.handleClearDate(name,e)}}
            />
        );
    }
}
